import type { CageWelfareOverviewResponseDto } from '@/services/types';

import { mapWelfareToDomain } from '../client/mappers';

import type { CageWelfareOverview } from './types';

export function mapCageWelfareOverviewToDomain(
    dto: CageWelfareOverviewResponseDto
): CageWelfareOverview {
    return {
        welfare: dto.welfare ? mapWelfareToDomain(dto.welfare) : undefined,
        swimSpeed: dto.swimSpeed
            ? {
                  swimSpeed: dto.swimSpeed.swimSpeed,
                  lastSpeedMeasurement: dto.swimSpeed.lastSpeedMeasurement,
                  daypartTag: dto.swimSpeed.daypartTag ?? null,
              }
            : undefined,
    };
}
